var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRecuring(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.3032 13.4258C19.7772 13.2588 19.2152 13.5498 19.0472 14.0758C18.1102 17.0218 15.3522 18.9998 12.1842 18.9998C8.22218 18.9998 5.00018 15.8598 5.00018 11.9998C5.00018 8.1408 8.22218 4.9998 12.1842 4.9998C13.9122 4.9998 15.5422 5.6018 16.8292 6.6698L14.6632 6.3128C14.1132 6.2128 13.6032 6.5918 13.5132 7.1358C13.4232 7.6808 13.7922 8.1958 14.3372 8.2848L18.5832 8.9868C18.6382 8.9958 18.6942 8.9998 18.7472 8.9998C18.8662 8.9998 18.9822 8.9788 19.0902 8.9388C19.1272 8.9248 19.1572 8.8988 19.1932 8.8798C19.2592 8.8458 19.3282 8.8158 19.3852 8.7678C19.4212 8.7388 19.4442 8.6968 19.4752 8.6628C19.5222 8.6138 19.5722 8.5668 19.6072 8.5068C19.6322 8.4638 19.6422 8.4128 19.6612 8.3648C19.6852 8.3058 19.7172 8.2508 19.7292 8.1858L20.4832 4.1858C20.5852 3.6428 20.2282 3.1188 19.6852 3.0178C19.1442 2.9198 18.6192 3.2728 18.5172 3.8148L18.2452 5.2558C16.5812 3.8148 14.4482 2.9998 12.1842 2.9998C7.12018 2.9998 3.00018 7.0368 3.00018 11.9998C3.00018 16.9628 7.12018 20.9998 12.1842 20.9998C16.2262 20.9998 19.7502 18.4608 20.9532 14.6818C21.1202 14.1558 20.8292 13.5938 20.3032 13.4258Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecuring);
export default __webpack_public_path__ + "static/media/recuring.3cd55ca0f4d1b45d69ab496dd0a8728d.svg";
export { ForwardRef as ReactComponent };